import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/api";

// Accès rapide à l'espace d'administration, présent sur toutes les pages
// mais visible UNIQUEMENT pour un utilisateur connecté avec le rôle admin.
export default function AdminFlottant() {
  const { user } = useAuth();
  const nav = useNavigate();
  if (!user || user.role !== "admin") return null;
  return (
    <button
      onClick={() => nav("/admin")}
      data-testid="admin-flottant"
      style={{
        position: "fixed", bottom: 22, left: 22, height: 44, padding: "0 16px",
        display: "inline-flex", alignItems: "center", gap: 8, borderRadius: 24,
        background: "var(--navy)", color: "#fff", border: "1.5px solid var(--gold)",
        fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: 13.5,
        cursor: "pointer", boxShadow: "0 6px 18px rgba(0,0,0,.22)", zIndex: 60,
        transition: "transform .15s",
      }}
      onMouseDown={(e) => { e.currentTarget.style.transform = "scale(.95)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
      aria-label="Ouvrir l'administration AfriFuté"
    >
      <ShieldCheck size={17} color="var(--gold)" /> Admin AfriFuté
    </button>
  );
}
